import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";
import 'lenis/dist/lenis.css';
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
   <HashRouter>
  <App />
</HashRouter>
  </StrictMode>,
);
